export default __webpack_public_path__ + "static/gilroy-regular-dfcff34bc26aff810aa2e0fb0b34edf5.woff2";